import { Circle } from '@mui/icons-material'
import { Box, Grid, Stack, Typography } from '@mui/material'
import React from 'react'
import DocLink from '../../components/DocLink'

const Welcome = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography textAlign="center">
          AmbuNet is an all-in-one platform for event medical management,
          clinical governance, fleet and equipment, ePCRs, patient transport,
          command and control, and organisational compliance.
        </Typography>
        <Typography textAlign="center">
          This knowledgebase explains the parts of the system that are available
          to your organisation. Some tools are controlled by permissions,
          subscription tier, selected base locations, and local configuration.
        </Typography>
      </Grid>
      <Grid item xs={12} lg={6}>
        <Stack gap={1}>
          <Typography variant="title3">AmbuNet is designed for</Typography>
          <Box pl={2}>
            {[
              'Event medical providers',
              'Ambulance services',
              'Patient transport services',
              'First responder organisations',
              'Sports and motorsport medical teams',
              'Air ambulance services',
              'Search and rescue units',
              'CQC registered organisations',
            ].map((x, key) => (
              <Stack key={key} direction="row" gap={1} alignItems="center">
                <Circle sx={{ fontSize: '0.5rem', color: 'gray' }} />
                <Typography>{x}</Typography>
              </Stack>
            ))}
          </Box>
        </Stack>
      </Grid>
      <Grid item xs={12} lg={6}>
        <Stack gap={1}>
          <Typography variant="title3">Use AmbuNet to</Typography>
          <Box pl={2}>
            {[
              'Manage staff records, applications, training, and compliance',
              'Plan events, build operational documents, and manage shifts',
              'Track vehicles, assets, defects, VDIs, cleaning, and Make Ready',
              'Create, review, audit, and share patient care records',
              'Record medicines usage, drug bag checks, and audits',
              'Track incidents, KPIs, meetings, policies, SOPs, and PGDs',
              'Manage patient transport patients, bookings, duties, and control',
              'Coordinate resources, incidents, tactical logs, and treatment centres',
              'Raise invoices, record payments, and run finance reporting',
              'Prepare for CQC inspections with evidence, gaps, and readiness scores',
            ].map((x, key) => (
              <Stack key={key} direction="row" gap={1} alignItems="center">
                <Circle sx={{ fontSize: '0.5rem', color: 'gray' }} />
                <Typography>{x}</Typography>
              </Stack>
            ))}
          </Box>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Stack gap={1}>
          <Typography variant="title3">Where to start</Typography>
          <Box pl={2}>
            <Stack gap={0.5}>
              <Typography>
                <strong>Setting up a new organisation?</strong> Follow{' '}
                <DocLink
                  docsPage
                  url="/getting-started/onboarding"
                  text="Onboarding Your Organisation"
                />{' '}
                — the setup wizard and the Getting Started checklist, in order.
              </Typography>
              <Typography>
                <strong>New crew member?</strong> Start with the{' '}
                <DocLink
                  docsPage
                  url="/getting-started/home-screen"
                  text="Home Screen"
                />{' '}
                to learn what you'll see when you sign in and what to click
                first.
              </Typography>
              <Typography>
                <strong>New to AmbuNet?</strong> Learn the ⌘K search, the
                sidebar, favourites, and the help drawer in{' '}
                <DocLink
                  docsPage
                  url="/getting-started/finding-your-way"
                  text="Finding Your Way Around"
                />
                .
              </Typography>
              <Typography>
                <strong>Manager or Supervisor?</strong> Get to know the{' '}
                <DocLink
                  docsPage
                  url="/getting-started/global-overview"
                  text="Global Overview"
                />{' '}
                dashboard.
              </Typography>
              <Typography>
                <strong>Wondering who can see what?</strong> See{' '}
                <DocLink
                  docsPage
                  url="/getting-started/permissions"
                  text="Permissions"
                />
                .
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </Grid>
    </Grid>
  )
}

export default Welcome
